module.exports = __webpack_public_path__ + "img/aston-online-course.03c005c5.jpg";